import ArchiveFiltersController from '../ArchiveFiltersController';
import type { ArchiveFilterModule } from '../types';

class SearchFilter implements ArchiveFilterModule {
    private controller: ArchiveFiltersController | null = null;
    private form: HTMLFormElement | null = null;
    private input: HTMLInputElement | null = null;
    private submitBtn: HTMLButtonElement | null = null;
    private resetBtn: HTMLButtonElement | null = null;
    private loadingIndicator: HTMLElement | null = null;

    public mount(controller: ArchiveFiltersController): void {
        this.controller = controller;
        this.init();
    }

    private init(): void {
        this.form = document.querySelector<HTMLFormElement>('[data-search-form]');
        this.input = document.querySelector<HTMLInputElement>('[data-search-form-input]');
        this.submitBtn = document.querySelector<HTMLButtonElement>('[data-search-form-submit]');
        this.resetBtn = document.querySelector<HTMLButtonElement>('[data-search-form-reset]');
        this.loadingIndicator = document.querySelector<HTMLElement>('[data-search-form-loading]');

        if (!this.form || !this.input) {
            return;
        }

        if (!this.controller) {
            return;
        }

        const state = this.controller.getState();

        if (state.search) {
            this.input.value = state.search;
            this.toggleResetButton();
        }

        this.bindEvents();

        this.controller.onStateChange((state) => {
            if (this.input && state.search !== this.input.value) {
                this.input.value = state.search;
                this.toggleResetButton();
            }
        });

        this.controller.onLoadingChange((isLoading) => {
            this.toggleLoadingState(isLoading);
        });

        this.toggleLoadingState(this.controller.getIsLoading());
    }

    private bindEvents(): void {
        if (!this.form || !this.input) {
            return;
        }

        this.form.addEventListener('submit', (event) => {
            event.preventDefault();
            this.performSearch();
        });

        this.input.addEventListener('input', () => {
            this.toggleResetButton();
        });

        if (this.resetBtn) {
            this.resetBtn.addEventListener('click', () => {
                this.resetSearch();
            });
        }
    }

    private toggleResetButton(): void {
        if (!this.input || !this.resetBtn || !this.submitBtn) {
            return;
        }

        if (this.input.value.trim()) {
            this.resetBtn.classList.remove('hidden');
            this.submitBtn.classList.remove('hidden');
        } else {
            this.resetBtn.classList.add('hidden');
            this.submitBtn.classList.add('hidden');
        }
    }

    private toggleLoadingState(isLoading: boolean): void {
        if (this.submitBtn) {
            if (isLoading) {
                this.submitBtn.setAttribute('disabled', 'true');
            } else {
                this.submitBtn.removeAttribute('disabled');
            }
        }

        if (this.loadingIndicator) {
            this.loadingIndicator.classList.toggle('hidden', !isLoading);
        }
    }

    private performSearch(): void {
        if (!this.input) {
            return;
        }

        this.controller?.setSearch(this.input.value.trim());
    }

    private resetSearch(): void {
        if (!this.input) {
            return;
        }

        this.input.value = '';
        this.toggleResetButton();
        this.performSearch();
    }
}

export default SearchFilter;